import { get } from '@/app/core/request';
import { HealthRoutes } from '@/app/api-routes';

class HealthApi {
  async check() {
    return get<any>(HealthRoutes.check);
  }
}

export default new HealthApi();
